import { Typography } from "@mui/material";
import AlertComponent from "../../external/ensolvers-core-frontend-mui/components/Common/AlertComponentMUI";
import NotificationService from "../../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/NotificationService";
import Certification from "../../models/Certification";
import CertificationService from "../../services/CertificationService";
import { CertificationStatus } from "../../utils/enums/Certification/CertificationStatus";
import { AppDialog } from "../AppDialog";

interface Props {
  certification: Certification | undefined;
  onClose: () => void;
  onChangeStatus: () => void;
  status: string;
  handleDenial?: (certificationExternalId: string, status: CertificationStatus) => void;
}

export default function CertificationStatusDialog(props: Props) {
  return (
    <>
      <AppDialog
        open={!!props.certification}
        onClose={() => props.onClose()}
        title={
          props.status === CertificationStatus.APPROVED
            ? `Approve certification of ${props.certification?.ownerFullName}`
            : props.status === CertificationStatus.DENIED
              ? `Deny certification of ${props.certification?.ownerFullName}`
              : ""
        }
        content={
          <>
            {props.status === CertificationStatus.APPROVED ? (
              <Typography>{`Do you want to approve this certification?`}</Typography>
            ) : props.status === CertificationStatus.DENIED ? (
              <Typography>{`Do you want to deny this certification?`}</Typography>
            ) : undefined}
          </>
        }
        buttons={[
          {
            label: "Confirm",
            onClick: props.onChangeStatus,
          },
        ]}
      />
    </>
  );
}
